<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine></BaseTopLine>

    <div class="tw-px-[26px]">
      <div class="tw-mb-[15px] tw-flex tw-items-center tw-gap-[10px]">
        <button class="tw-app-btn-primary" @click="openCreateAdsModal">
          <img
            :src="require(`@/assets/icons/addwhite.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["registry_ads_text1"] }}
        </button>
        <button class="tw-app-btn-primary-outline" @click="acceptAdsDelete">
          <img
            :src="require(`@/assets/icons/minus-dark.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["registry_ads_text2"] }}
        </button>
      </div>
    </div>

    <div class="tw-px-[26px] tw-relative">
      <BaseLoader v-if="adSourceLoadStatus == 'request'"></BaseLoader>
      <ve-table
        class="rest-style-table fixed-header"
        style="width: 100%"
        :columns="columns"
        :table-data="adSourceData"
        :border-x="true"
        :border-y="true"
        row-key-field-name="ads__id"
        :checkbox-option="{
          hideSelectAll: false,
          selectedRowChange: selectedRowChange,
          selectedAllChange: selectedAllChange,
        }"
        v-if="adSourceLoadStatus == 'success' || adSourceLoadStatus == 'error'"
        :clickHighlight="false"
        :rowStyleOption="{
          hoverHighlight: true,
        }"
        :eventCustomOption="eventCustomOption"
        :cellSelectionOption="{ enable: false }"
      />
    </div>

    <BaseModal
      name="adsModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="beforeClose"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('adsModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{
              modalOpenMode == "edit"
                ? dataLang["registry_ads_text6"]
                : dataLang["registry_ads_text5"]
            }}
          </div>

          <div
            :class="errorList.hasOwnProperty('ads__name') ? 'input-error' : ''"
            ref="ads__name"
          >
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              placeholder=""
              input-name="ads__name"
              @input="updateValue"
              :value="dataForEmit.ads__name"
            >
            </BaseInputNew>
          </div>

          <div ref="ads__comment" class="tw-mt-[10px]">
            <div class="tw-text-forText tw-mb-[5px]">
              {{ dataLang["registry_ads_text4"] }}
            </div>
            <BaseTextarea
              inputClass="tw-app-input-type-3"
              placeholder=""
              input-name="ads__comment"
              @onInput="updateValue"
              :minHeight="'160'"
              :value="dataForEmit.ads__comment"
            >
            </BaseTextarea>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="closeModal"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["registry_ads_text8"] }}
            </button>
            <button
              @click="modalAction"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["registry_ads_text7"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="acceptAdsDelete"
      width="420"
      height="auto"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptAdsDelete')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-text-[23px] tw-mb-[15px]">
            {{ dataLang["vehicle_modal_service_modals_warning4"] }}
          </div>

          <div class="tw-h-[10px]"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('acceptAdsDelete')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="deleteRow('acceptAdsDelete')"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_delete_ok"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import SimpleModal from "../components/vehicles-page-single-modal-inner/SimpleModal.vue";
import EventBus from "@/event-bus.js";
export default {
  components: {
    VeTable,
    SimpleModal,
  },

  props: {},
  data() {
    return {
      activeSelectRowsMultiple: null,
      updatedValues: {},
      dataForEmit: {},
      dataForModal: {},
      currentOpenedId: null,
      modalOpenMode: "create",
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.modalOpenMode = "edit";
              this.$modal.show("adsModal");
              this.currentOpenedId = row.ads__id;

              this.dataForEmit = {
                ...this.dataForEmit,
                ...row,
              };

              this.updatedValues = {
                ...this.updatedValues,
                ...row,
              };
            },
          };
        },
      },
    };
  },
  methods: {
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },

    openCreateAdsModal() {
      this.modalOpenMode = "create";
      this.$modal.show("adsModal");
    },

    acceptAdsDelete() {
      if (this.activeSelectRowsMultiple?.length) {
        this.$modal.show("acceptAdsDelete");
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },

    clearInputs() {
      Object.keys(this.dataForEmit).forEach((elem, index) => {
        if (this.$refs[elem]) {
          this.$refs[elem].classList.remove("input-error");
        }
      });
    },

    beforeClose(event) {
      this.dataForEmit = {};
      this.updatedValues = {};
      this.selectedRow = {};
      this.clearInputs();
      this.clearErrorList();
    },

    closeModal() {
      this.$modal.hide("adsModal");
    },

    modalAction() {
      if (this.modalOpenMode == "create") {
        this.commitCreate();
      } else {
        this.commitAlter();
      }
    },

    commitCreate() {
      this.createAdSourceData({
        data: this.updatedValues,
        callback: () => {
          this.$modal.hide("adsModal");
          this.clearInputs();
        },
      });
    },

    commitAlter() {
      this.editAdSourceSingular({
        id: this.currentOpenedId,
        dataEdit: this.updatedValues,
        callback: () => {
          this.$modal.hide("adsModal");
          this.clearInputs();
        },
      });
    },

    deleteRow(nameModal) {
      this.deleteAdSourceData(this.activeSelectRowsMultiple);
      this.activeSelectRowsMultiple = null;
      // EventBus.$emit("closeModal", { nameForAction: nameModal });
      this.$modal.hide("acceptAdsDelete");
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
      this.clearErrorList();
      this.$refs[data.name].classList.remove("input-error");
    },

    ...mapActions("adSourceModule", [
      "getAdSourceAll",
      "createAdSourceData",
      "editAdSourceSingular",
      "deleteAdSourceData",
      "clearErrorList",
    ]),
  },

  mounted() {},

  created() {
    this.getAdSourceAll({
      params: {
        page: 1,
        limit: 100,
      },
    });
  },

  computed: {
    ...mapState("adSourceModule", [
      "adSourceData",
      "adSourceLoadStatus",
      "paginationAdSourceStateParams",
      "errorList",
    ]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapGetters("adSourceModule", ["numPages"]),

    columns() {
      return [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "ads__name",
          key: "1",
          title: this.dataLang["registry_ads_text3"],
          align: "left",
          width: "20%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "ads__comment",
          key: "2",
          title: this.dataLang["registry_ads_text4"],
          align: "left",
          width: "77%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
      ];
    },
  },
};
</script>
